<template>
  <b-modal ok-only id="order-tag-logs" title="Tag Activity Logs"  size="lg">
      <b-table striped hover :items="logs" :fields="fields" v-if="!processing && logs.length > 0"></b-table>
      <div v-else-if="!processing && logs.length == 0" class="text-info">No Logs Found</div>
      <b-spinner v-else variant="primary" type="grow" label="Spinning"></b-spinner>
  </b-modal>
</template>

<script>
import OrderTagsService from '../../services/order-tags.service';
import EventBus from '../../EventBus';
  export default {
     data(){
       return {
         processing: false,
         fields: [
           {key: "previousTags", label: 'Previous Tags'},
           {key: "currentTags", label: 'Set Tags'},
           {key: "User.username", label: "Action By"},
           {key: "User.email", label: "Action By User Email"},
           {key: "createdAt", label: "Created At"},
         ],
         logs: [],
       }
     },
     mounted(){
       EventBus.$on('order-tags-log-modal-opened', orderId => {
          this.getOrderTagLogs(orderId)
       })
     },
     methods: {
        async getOrderTagLogs(orderId){
           this.processing = true;
           const result = await OrderTagsService.fetchOrderTagLogs(orderId);
           this.logs = result.data.logs
           this.processing = false;
        }
     },
     beforeDestroy(){
       EventBus.$off('order-tags-log-modal-opened');
     }
  }
</script>

<style lang="scss" scoped>

</style>